export const Font = {
    title: {
        fontFamily: 'Inter',
        fontSize: 60
    },
    title2: {
        fontFamily: 'Inter',
        fontSize: 45,
        fontWeight: 'bold'
    },
    subTitle: {
        fontFamily: 'Inter',
        fontSize: 30,
        fontWeight: 'bold'
    },
    subTitle2: {
        fontFamily: 'Inter',
        fontSize: 30,
        fontWeight: 'bold'
    },
    text: {
        fontFamily: 'Inter',
        fontSize: 30
    },
    text2: {
        fontFamily: 'Inter',
        fontSize: 30,
        fontWeight: 'bold'
    },
    menu: {
        fontFamily: 'Inter',
        fontSize: 20
    },
    button: {
        fontFamily: 'Inter',
        fontSize: 25,
        fontWeight: 'bold'
    },
    legend: {
        fontFamily: 'Inter',
        fontSize: 25
    }
}